export function handleNavigation(event: any) {
  // const { href, origin } = event.target
  const button = event.currentTarget
  const scrollTopValue = button.getBoundingClientRect().top + window.scrollY
  const element = window.document.querySelector(
    '#dialog-btn'
  ) as HTMLButtonElement
  if (element) {
    element.click()
  }
  // const { href, origin } = window.location
  // const condition = href.slice( 0, href.length - 1 ) === origin
  // setTimeout(
  //   () => {
  //     scrollToSignup()
  //   },
  //   condition ? 0 : 1200
  // )
  // const inputElement = document.getElementsByName( 'email' )[0];
  // if ( inputElement ) {
  //   inputElement.focus();
  // }
}
function scrollToSignup() {
  const signup = document.getElementById('signup')
  const offset = 70
  if (!signup) {
    return // exit the function if the element does not exist
  }
  const bodyRect = document.body.getBoundingClientRect().top
  const signupRect = signup.getBoundingClientRect().top
  const scrollTo = signupRect - bodyRect - offset
  window.scrollTo({
    top: 0
  })
  setTimeout(() => {
    window.scrollTo({
      top: scrollTo,
      behavior: 'smooth'
    })
  }, 500)
}

export function formatNumber(
  n: number,
  obj?: { maxFractionDigits?: number; notation?: 'compact' }
) {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits:
      typeof obj?.maxFractionDigits === 'number' ? obj?.maxFractionDigits : 2,
    notation: obj?.notation
  }).format(n)
}

export function formatCurrency(
  amount: number,
  obj?: { maxFractionDigits?: number; notation?: 'compact' }
) {
  const formatting_options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits:
      typeof obj?.maxFractionDigits === 'number' ? obj?.maxFractionDigits : 2,
    notation: obj?.notation
  }
  const dollarString = new Intl.NumberFormat('en-US', formatting_options)
  return dollarString.format(amount)
}
